import React from 'react';
import { Result, Button, Typography, Space } from 'antd';
import { LockOutlined, MailOutlined } from '@ant-design/icons';
import PageTemplate from './PageTemplate';
import { useStateContext } from '../../contexts/ContextProvider';

const { Paragraph, Text } = Typography;

const NoAccess = () => {
  const { user } = useStateContext();
  
  const handleAuthClick = () => {
    // Dacă suntem în contextul PageTemplate, acesta se va ocupa de afișarea modalului
    const event = new CustomEvent('openAuthModal');
    window.dispatchEvent(event);
  };

  return (
    <PageTemplate title="Acces restricționat">
      <Result
        status="403"
        icon={<LockOutlined style={{ color: '#ff4d4f' }} />}
        title="Nu aveți acces la această resursă"
        subTitle="Ne pare rău, nu aveți permisiunile necesare pentru a accesa această pagină."
        extra={
          <Space direction="vertical" size="large" style={{ width: '100%' }}>
            {!user ? (
              <div className="text-center">
                <Paragraph>
                  Vă rugăm să vă autentificați pentru a verifica dacă aveți acces.
                </Paragraph>
                <Button 
                  type="primary" 
                  size="large" 
                  onClick={handleAuthClick}
                  className="mt-4"
                >
                  Autentificare
                </Button>
              </div>
            ) : (
              <Paragraph>
                Contul dvs. actual nu are permisiunile necesare pentru această secțiune.
              </Paragraph>
            )}
            
            <div className="bg-blue-50 p-6 rounded-lg border border-blue-200 mt-8">
              <Typography.Title level={4}>Aveți nevoie de asistență?</Typography.Title>
              <Paragraph>
                Dacă considerați că ar trebui să aveți acces la această resursă, vă rugăm să contactați administratorul sistemului:
              </Paragraph>
              <Paragraph>
                <Space>
                  <MailOutlined />
                  <Text copyable>admin@DANCO.com</Text>
                </Space>
              </Paragraph>
              <Paragraph className="text-sm text-gray-500 mt-2">
                Vă rugăm să includeți numele dvs. de utilizator și pagina la care încercați să accesați în e-mail.
              </Paragraph>
            </div>
          </Space>
        }
      />
    </PageTemplate>
  );
};

export default NoAccess;
